var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.viewMode === "list"
    ? _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.menu, function(option, index) {
          return _c(
            "div",
            { key: index, staticClass: "col-12 col-md-6 mt-3" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "list-row d-flex align-items-center justify-content-between"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "list-row-content d-flex align-items-center cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.navigate(option, $event)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "list-row-icon rounded-circle",
                        attrs: { src: _vm.showImage(option.mainImage) }
                      }),
                      _c("span", { staticClass: "list-row-title" }, [
                        _vm._v(_vm._s(option.title))
                      ])
                    ]
                  ),
                  _vm.showStar
                    ? _c("span", { staticClass: "star font-20" }, [
                        !option.isFavorite
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-star fill cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("add", option)
                                  }
                                }
                              }),
                              _c("i", {
                                staticClass: "far fa-star unfill cursor-pointer"
                              })
                            ])
                          : _c("div", [
                              _c("i", {
                                staticClass:
                                  "fas fa-star text-warning cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("remove", option)
                                  }
                                }
                              })
                            ])
                      ])
                    : _vm._e()
                ]
              )
            ]
          )
        }),
        0
      )
    : _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 flip-cards-container pr-0 pl-0" },
          _vm._l(_vm.menu, function(option, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "flip-card col-lg-3 col-md-6 mt-4 col-6",
                class: _vm.rotateCard(option) ? "card-rotate" : ""
              },
              [
                _c("div", { staticClass: "flip-card-inner" }, [
                  _c("div", [
                    _c("div", { staticClass: "flip-card-front" }, [
                      _vm.showStar
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "star font-20 d-flex justify-content-end mr-3 mt-2"
                            },
                            [
                              !option.isFavorite
                                ? _c("div", [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-star fill cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("add", option)
                                        }
                                      }
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "far fa-star unfill cursor-pointer"
                                    })
                                  ])
                                : _c("div", [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-star text-warning cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("remove", option)
                                        }
                                      }
                                    })
                                  ])
                            ]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "text-decorator" }, [
                        _c("div", { staticClass: "col-xs-7" }, [
                          _c("img", {
                            staticClass: "rounded-circle",
                            attrs: { src: _vm.showImage(option.mainImage) }
                          }),
                          _c("h3", { staticClass: "card-front-title" }, [
                            _vm._v(" " + _vm._s(option.title) + " ")
                          ]),
                          _c("p", { staticClass: "px-4 card-front-p mb-3" }, [
                            _vm._v(" " + _vm._s(option.description) + " ")
                          ])
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "flip-card-back cursor-pointer" },
                      [
                        _vm.showStar
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "star font-20 d-flex justify-content-end mr-3 mt-2 mb-5 float-right"
                              },
                              [
                                !option.isFavorite
                                  ? _c("div", [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-star fill cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit("add", option)
                                          }
                                        }
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "far fa-star unfill cursor-pointer"
                                      })
                                    ])
                                  : _c("div", [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-star text-warning cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit("remove", option)
                                          }
                                        }
                                      })
                                    ])
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            class: _vm.showStar
                              ? "back-content-with-start"
                              : "",
                            on: {
                              click: function($event) {
                                return _vm.navigate(option, $event)
                              }
                            }
                          },
                          [
                            !_vm.showStar
                              ? _c("div", { staticClass: "text-right" }, [
                                  _c("img", {
                                    staticClass: "rounded-circle",
                                    attrs: {
                                      src: _vm.showImage(option.hoverImage)
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _c("h3", { staticClass: "px-4 card-back-title" }, [
                              _vm._v(" " + _vm._s(option.title) + " ")
                            ]),
                            _c("p", { staticClass: "card-back-p px-4 pb-2" }, [
                              _vm._v(" " + _vm._s(option.detail) + " ")
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          }),
          0
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }